import { formatPermissionsArray } from '../domains/permissionGroups/formatPermissions';
import { GenericResponse, GroupPermissions, Section } from '../types';
import { getHeaders, tosApi } from './tosApi';

type PermissionGroupResponse = GenericResponse & {
  results: GroupPermissions[];
};

export const groupsApi = tosApi.injectEndpoints({
  endpoints: (build) => ({
    getPermissionsGroup: build.query<PermissionGroupResponse, void>({
      query: () => {
        return {
          url: `core/groups`,
          method: 'GET',
          headers: getHeaders,
        };
      },
      providesTags: [{ type: 'Group', id: 'LIST' }],
    }),
    createPermissionGroup: build.mutation<any, GroupPermissions>({
      query: (permissionGroup) => {
        return {
          url: `core/groups`,
          method: 'POST',
          body: permissionGroup,
        };
      },
      invalidatesTags: [{ type: 'Group', id: 'LIST' }],
    }),
    updatePermissionGrup: build.mutation<
      any,
      Partial<GroupPermissions> & Pick<GroupPermissions, 'id'>
    >({
      query: ({ id, ...permissionGroup }) => {
        return {
          url: `core/groups/${id}`,
          method: 'PUT',
          body: permissionGroup,
        };
      },
      invalidatesTags: [{ type: 'Group', id: 'LIST' }],
    }),
    deletePermissionGroup: build.mutation<any, number>({
      query: (id) => {
        return {
          url: `core/groups/${id}`,
          method: 'DELETE',
        };
      },
      invalidatesTags: [{ type: 'Group', id: 'LIST' }],
    }),
    getPermissions: build.query<any, void>({
      query: () => {
        return {
          url: `core/permissions`,
          method: 'GET',
        };
      },
      transformResponse: (response: any) => {
        return formatPermissionsArray(response);
      },
    }),
    getSections: build.query<Section[], void>({
      query: () => {
        return {
          url: `core/sections`,
          method: 'GET',
          headers: getHeaders,
        };
      },
    }),
    getGroupSections: build.query<Section[], number>({
      query: (groupId) => {
        return {
          url: `core/groups/${groupId}/sections`,
          method: 'GET',
          headers: getHeaders,
        };
      },
      providesTags: (_result, _error, groupId) => [
        { type: 'GroupSections', id: groupId },
      ],
    }),
    updateGroupSections: build.mutation<
      Section[],
      { id: number; sections: string[] }
    >({
      query: ({ id, sections }) => {
        return {
          url: `core/groups/${id}/sections`,
          method: 'PUT',
          body: { sections },
        };
      },
      invalidatesTags: (_result, _error, { id }) => [
        { type: 'GroupSections', id },
      ],
    }),
  }),
});
export const {
  useGetPermissionsGroupQuery,
  useCreatePermissionGroupMutation,
  useUpdatePermissionGrupMutation,
  useDeletePermissionGroupMutation,
  useGetPermissionsQuery,
  useGetSectionsQuery,
  useGetGroupSectionsQuery,
  useUpdateGroupSectionsMutation,
} = groupsApi;
